import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useTradeRoutesConditions } from '@pages/Trade/Trade.routes'

import { useSessionEntity } from '@context/EntityContext'

import { ChartBarIcon } from '@ui/icons/ChartBar.icon'
import { ChartPieIcon } from '@ui/icons/ChartPie.icon'
import { SuitcaseIcon } from '@ui/icons/Suitcase.icon'
import { TrendUpIcon } from '@ui/icons/TrendUp.icon'

import { TickmillCompaniesEnum } from '@utils/companyName.utils'

import { TickmillProductType } from '@model/TickmillProductType'

import { MenuSection, useWithMobileIcon } from '../useMenuSections'

export const useTradeMenu = (): MenuSection => {
  const { t } = useTranslation()
  const { canAccessTrade } = useTradeRoutesConditions()
  const entity = useSessionEntity()
  const isTMSC = entity === TickmillCompaniesEnum.TICKMILL_SC
  const isTradingEnabled = isTMSC && !!canAccessTrade
  const withMobileIcon = useWithMobileIcon()

  return useMemo(
    () => ({
      id: 'trade-menu',
      label: t('Tabs.Trade'),
      icon: TrendUpIcon,
      condition: isTradingEnabled,
      products: [TickmillProductType.CFD],
      children: [
        {
          id: 'markets',
          label: t('Tabs.Markets'),
          path: '/dashboard/trade/markets',
          products: [TickmillProductType.CFD],
          icon: withMobileIcon(ChartBarIcon),
          tourTarget: 'trade.markets',
        },
        {
          id: 'portfolio',
          label: t('Tabs.Portfolio'),
          path: '/dashboard/trade/portfolio',
          products: [TickmillProductType.CFD],
          icon: withMobileIcon(SuitcaseIcon),
          tourTarget: 'trade.portfolio',
        },
        {
          id: 'analytics',
          label: t('Tabs.Analytics'),
          path: '/dashboard/trade/analytics',
          products: [TickmillProductType.CFD],
          icon: withMobileIcon(ChartPieIcon),
          tourTarget: 'trade.analytics',
        },
      ],
    }),
    [t, withMobileIcon, isTradingEnabled]
  )
}
